export default {
  "phoneInvalid": "Ingresa un número de teléfono válido de 10 dígitos",
  "emailRequired": "La dirección de correo electrónico es obligatoria",
  "emailInvalid": "Ingresa una dirección de correo electrónico válida",
  "emailMultipleAt": "La dirección de correo electrónico debe contener exactamente un símbolo @",
  "emailInvalidDomain": "La dirección de correo electrónico tiene una extensión de dominio no válida",
  "emailDisposable": "Usa una dirección de correo electrónico que no sea desechable",
  "emailConsecutiveSpecialChars": "La dirección de correo electrónico contiene caracteres especiales consecutivos",
  "emailInvalidPositionSpecialChars": "La dirección de correo electrónico contiene caracteres especiales en posiciones no válidas",
  "emailIpDomain": "La dirección de correo electrónico no puede usar una dirección IP como dominio",
  "cityContainsNumbers": "El nombre de la ciudad no puede contener números",
  "cityInvalidChars": "El nombre de la ciudad solo puede contener letras y espacios",
  "streetInvalidChars": "La dirección solo puede contener letras, números, espacios, comas y #",
  "birthDateTooYoung": "Debes tener al menos 18 años",
  "birthDateInvalid": "Ingresa una fecha de nacimiento válida",
  "zipInvalid": "Ingresa un código postal válido de 5 dígitos"
} as const;
